import type { QueryClient } from '@tanstack/react-query';
import type { Sport } from '@sharpr/types';

/**
 * THE owner of "server-side pricing changed — what must refetch".
 *
 * Every cached surface whose contents derive from effective PMFs / analyst
 * decisions / an active release is listed here ONCE. Consumed by:
 *  - `usePricedSurfaceVersion` — the server's push channel,
 *    so EVERY client converges within one poll tick of any repricing
 *    (publish, hide, model run, cron), and
 *  - admin mutation handlers — so the acting client repriced instantly
 *    instead of waiting out the poll tick.
 *
 * Adding a new priced query surface? Register its key prefix here — a key
 * invalidated only at its mutation site recreates the "hard refresh needed"
 * bug for every other client.
 */
export function invalidatePricedSurfaces(
  queryClient: QueryClient,
  sport: Sport,
): void {
  queryClient.invalidateQueries({ queryKey: ['players', 'odds', sport] });
  queryClient.invalidateQueries({ queryKey: ['pmf', sport] });
  if (sport === 'mlb') {
    queryClient.invalidateQueries({ queryKey: ['admin', 'mlb-projections'] });
    queryClient.invalidateQueries({ queryKey: ['admin', 'mlb-best-edges'] });
  }
}
